import React from "react"
import getStyles from "./get-styles"

const AlignmentTable = ({ alignment, className, children, margin }) => (
  <table
    className={className}
    width="100%"
    border="0"
    cellSpacing="0"
    cellPadding="0"
    style={{ margin }}
  >
    <tr>
      <td align={alignment}>{children}</td>
    </tr>
  </table>
)

const ButtonTable = ({
  children,
  backgroundColor,
  borderRadius,
  width,
  padding
}) => {
  return (
    <table border="0" cellSpacing="0" cellPadding="0" width={width}>
      <tr>
        <td
          align="center"
          bgcolor={backgroundColor}
          style={{ backgroundColor, borderRadius, overflow: "hidden", padding }}
        >
          {children}
        </td>
      </tr>
    </table>
  )
}

const ButtonLink = ({
  href,
  children,
  color,
  borderWidth,
  borderColor,
  fontSize,
  padding,
  triggerId
}) => {
  const overrideProps = {
    color,
    borderWidth,
    borderColor,
    padding,
    fontSize
  }
  const style = {
    backgroundColor: "inherit",
    display: "inline-block",
    textDecoration: "none",
    borderWidth: 0,
    borderStyle: "solid",
    margin: 0,
    ...overrideProps
  }

  return (
    <a
      className="email-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={style}
      trigger-id={triggerId}
      data-ck-element="button"
    >
      {children}
    </a>
  )
}

const Button = ({ children, data }) => {
  let { href, triggerId } = data

  const style = getStyles(data)

  const {
    backgroundColor,
    color,
    fontSize,
    margin,
    width,
    borderColor,
    borderRadius,
    borderWidth,
    padding,
    textAlign
  } = style

  return (
    <>
      <except-outlook>
        <table width="100%">
          <tbody>
            <tr>
              <td align={textAlign}>
                <a
                  className="email-button"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    borderWidth: 0,
                    borderColor: "currentColor",
                    ...style
                  }}
                  trigger-id={triggerId}
                >
                  {children}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </except-outlook>
      <outlook-only>
        <AlignmentTable
          className="button-table"
          alignment={textAlign}
          margin={margin}
        >
          <ButtonTable
            backgroundColor={backgroundColor}
            borderRadius={borderRadius}
            width={width}
            padding={padding}
          >
            <ButtonLink
              href={href}
              borderColor={borderColor || backgroundColor}
              borderWidth={borderWidth}
              color={color}
              fontSize={fontSize}
              triggerId={triggerId}
            >
              {children}
            </ButtonLink>
          </ButtonTable>
        </AlignmentTable>
      </outlook-only>
    </>
  )
}

export default Button
